/**
 * Errors from Supabase (FunctionsHttpError, PostgrestError, AuthError, ...)
 * carry their details in non-enumerable properties, so `console.error(err)`
 * shows up as `{}` in console captures. Always log through logError() to get
 * the real message/details.
 */
export function serializeError(err: unknown): string {
  if (!err) return 'unknown error';
  if (typeof err === 'string') return err;
  const e = err as any;
  if (e instanceof Error) {
    return [e.name !== 'Error' ? e.name : null, e.message]
      .filter(Boolean)
      .join(': ') || e.message;
  }
  if (typeof e === 'object') {
    const parts = [e.message, e.code, e.details, e.hint].filter(Boolean);
    if (parts.length) return parts.join(' | ');
    try {
      const s = JSON.stringify(e);
      return s === '{}' ? String(e) : s;
    } catch {
      return String(e);
    }
  }
  return String(e);
}

export function logError(tag: string, err: unknown) {
  console.error(`${tag}: ${serializeError(err)}`);
}
